import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';
import util from '../util';

if (!window.Vuex) {
	Vue.use(Vuex);
}

const pageJson = window.____global.pageJson;

const global = {
	isLogin: pageJson.isLogin,
	user58pic: pageJson.user58pic,
	jobUrl: pageJson.jobUrl || '//m.58.com/job',
	source: pageJson.source ? pageJson.source : '', // 完整简历3，M微简历13，联盟18，百度百聘46，校招76
	resumeType: util.getParamVal('resumeType') || pageJson.resumeType, // 简历类型（完整简历1，M微简历2，联盟3）
	areaName: pageJson.areaName,
	categoryInitList: pageJson.categoryInitList// 默认选择的职位
};

// 简历发布提交字段
const submitData = {
	truename: '', //姓名（必传）
	gender: '', // 性别（必传）
	mobile: '', //手机号（必传）
	keyCode: '', //验证码
	education: '', //教育程度（必传）
	workyears: '', //工作年限（必传）
	birthday: '', //出生年份 yyyy-mm-dd（必传）
	targetAreaId: '', //意向工作地点 , 分割（必传）
	salary: '', //期望薪资（必传）
	zpcateId: '', //期望职位的归属id逗号分割（必传）
	from: global.source, //发布来源，完整简历，微简历，联盟，百度百聘（要传）校招简历
	responseid: '', // 获取手机验证码返回的responseID
	email: '', //邮箱
	native: '', //籍贯
	liveaddr: '', //现居住地
	pic: '', //头像
	educations: '', // 教育经历
	csrfToken: window.____global.csrfToken || '', // token信息
	tjfrom: util.getParamVal('tjfrom') || ''
};

// 隐私设置提交字段
const privacyData = {
	showStatus: 0,
	blockIndustry: 0
};

// 基础信息页面校验字段(默认是null，填写正确置为true，填写错误置为false)
const basicInfo = {
	truename: null,
	gender: null,
	mobile: null, //手机号
	keyCode: null, //验证码
	birthday: null, //出生年份 yyyy-mm-dd
	education: null, //教育程度
	workyears: null, //工作年限
	educations: null // 教育经历
};

// 求职意向页面校验字段
const expectionInfo = {
	zpcateId: false, // 期望职位(测试)
	salary: false, //期望薪资
	targetAreaId: false //意向工作地点（测试）
};

// 获取验证码接口信息
const captcha = {
	isSuccess: false,
	responseid: '',
	errorInfo: ''
};

// 投递参数信息
const deliveryObj = {
	infoId: util.getParamVal('infoids'),
	resumeId: '',
	deliverySource: util.getParamVal('deliverySource'),
	tjFrom: util.getParamVal('tjfrom'),
	finalCp: util.getParamVal('finalCp'),
	role: util.getParamVal('role'),
	wbtk: window.____global.csrfToken || '' // token信息
};

// 当前操作教育经历信息
const educationInfo = {
	gradschool: '', //学校名称
	gradmajor: '', //专业名称
	gradtime: '', //毕业时间
	eduIndex: -1, // 当前操作索引值
	eduState: 0 // 0-非新增非编辑状态 1-新增状态 2-编辑状态
};

// 教育经历校验字段(默认是null，填写正确置为true，填写错误置为false)
const educationCheck = {
	gradschool: null, //学校名称
	gradmajor: null, //专业名称
	gradtime: null //毕业时间
};

const state = {
	global,
	pagefromUrl: decodeURIComponent(util.getParamVal('from')) || '', // 来源页面URL
	isLogin: global.isLogin, // 登录状态
	resumeCount: 0, // 简历份数
	sessionCateList: [], // 缓存中期望职位数据
	sessionAreaList: [], // 缓存中期望区域数据
	originPic: '', // 上传的原始图片url
	areaInfo: [], // 区域信息
	hasAuthed: false, // 手机号是否已认证
	hasAuthedMobile: '', // 用户通过后置登录成功使用的手机号或者用户已认证的手机号，若使用此手机号则不再进行检查认证状态
	authMobile: '', // 后端返回的已认证的手机号
	captcha,
	basicInfo,
	expectionInfo,
	basicInfoOk: false, // 标记基础信息页面信息填写情况
	expectionInfoOk: false, // 标记求职意向页面信息填写情况
	educationOk: false, // 标记教育经历信息填写情况
	submitData,
	privacyData,
	resumeId: '', // 发布的简历id
	showIndustry: false, // 是否展示屏蔽行业选择
	uploadState: null, // 图片上传状态，默认为null
	submitState: null, // 基本简历发布状态，默认为null
	submitErrorInfo: '', // 简历发布错误提示
	privacySettingState: null, // 隐私设置状态
	privacyErrorInfo: '', // 隐私设置错误提示
	deliveryObj: deliveryObj, // 投递参数
	infoId: deliveryObj.infoId, // 职位id
	deliveryCode: '', // 投递返回的code
	deliveryState: false, // 投递状态
	deliveryMsg: '', //简历投递错误提示
	educationInfo,
	educationCheck,
	allConfigOtherData: {},
	showISDCaptcha: false,
	responseObj: null, // 滑动验证码返回参数
	/**
	 * fromEducation：教育培训
	 * fromWX：微信小程序
	 * fromTT：头条小程序
	 * fromBD：百度小程序
	 * fromXZ：校招
	 * fromCQXZ：重庆定制校招
	 * fromTZ：同镇
	 * defalt：默认
	 */
	pagefrom:
		util.getParamVal('pagefrom') === 'education'
			? 'fromEducation'
			: util.getParamVal('pagefrom')
			? util.getParamVal('pagefrom')
			: ['63', '104', '105', '152'].indexOf(deliveryObj.deliverySource) > -1
			? 'fromWX'
			: deliveryObj.deliverySource === '102'
			? 'fromTT'
			: deliveryObj.deliverySource === '103'
			? 'fromBD'
			: deliveryObj.deliverySource === '106'
			? 'fromZFB'
			: global.source === 76
			? 'fromXZ'
			: global.source === 94
			? 'fromCQXZ'
			: global.source === 77
			? 'fromTZ'
			: 'default'
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
});



// WEBPACK FOOTER //
// ./src/module/basic/store/index.js